import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, "pro Monat", -1)
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["innerHTML"]

import Product from '@/classes/Product';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductCardPrices',
  props: {
    product: {}
  },
  setup(__props: any) {

library.add(faInfoCircle);

const props = __props;

const fixedBonus = props.product.getSummedBonus('fixed');

return (_ctx: any,_cache: any) => {
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!
  const _component_IoTooltip = _resolveComponent("IoTooltip")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["product-card__prices", {
        'with-bonus': !!_unref(fixedBonus),
      }]),
    "data-eq-part": "product-card__prices"
  }, [
    _createElementVNode("div", null, [
      _createElementVNode("div", null, _toDisplayString(_ctx.product.getPriceFormatted('monthly')) + " €", 1),
      _hoisted_1
    ]),
    (_unref(fixedBonus))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", null, _toDisplayString(_unref(fixedBonus).valueGrossFormatted) + " €", 1),
          _createElementVNode("div", null, [
            _createTextVNode(_toDisplayString(_unref(fixedBonus).label) + " ", 1),
            (_unref(fixedBonus).description)
              ? (_openBlock(), _createBlock(_component_IoTooltip, {
                  key: 0,
                  class: "d-print-none"
                }, {
                  title: _withCtx(() => [
                    _createElementVNode("div", {
                      innerHTML: _unref(fixedBonus).description
                    }, null, 8, _hoisted_3)
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_FontAwesomeIcon, { icon: _unref(faInfoCircle) }, null, 8, ["icon"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})